import React from 'react';
export function ProductPresentation() {
  return <section className="bg-forest-900 text-forest-50 py-24 px-4 overflow-hidden relative" data-id="element-180">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-181"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-182">
        <p className="text-gold-400 font-bold tracking-widest uppercase mb-4" data-id="element-183">
          Presentamos
        </p>
        <h2 className="text-4xl md:text-6xl font-bold mb-12 leading-tight" data-id="element-184">
          PROTOCOLO RESCATE SIBO™
          <br data-id="element-185" />
          <span className="text-gold-500" data-id="element-186">SISTEMA COMPLETO</span>
        </h2>

        <div className="flex justify-center mb-12" data-id="element-187">
          <img src="https://cdn.magicpatterns.com/uploads/x98rBG67dLThdQ4p2Ybbqw/Mockup_(4).png" alt="Protocolo Rescate SIBO Sistema Completo" className="w-full max-w-2xl drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-188" />
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-189">
          <p className="text-xl md:text-2xl font-medium leading-relaxed mb-4 italic" data-id="element-190">
            El primer protocolo de nutrición vegetal funcional para la mujer
            argentina con síntomas compatibles con SIBO.
          </p>
        </div>
      </div>
    </section>;
}